import { initializeApp } from 'firebase/app';
import { api, endpointUrl } from './api';
import authHeader from './auth-header';
import { deleteToken, getMessaging } from 'firebase/messaging';

export type AnnounSheetDataResponse = {
    data: AnnounSheet[]
    current_page: number;
    from: number;
    to: number;
    total: number;
    per_page: number;
    first_page_url: string;
    last_page_url: string;
    next_page_url: string;
};
export type IAcknowledge={
    noticeBoardList:any;
}

export type NoticeBoardDataResponseCus = {
    noticeBoardTableData: AnnounSheetDataResponse,
    module_id: number,
};
export type AnnounSheet = {
    id: number,
    title: string,
    tag: string[],
    postedDate: string,
    expiryDate: string,
    postedBy: string,
    updatedBy: string,
    type: string,
    viewBy?: [],
    content: string,
    data?: any,
}

export type TagsResponse = {
    tagsData: TagsData[]
}
export type TagsResponseCustom = {
    tagList: TagsData[]
}
export type TagsData = {
    id: number,
    name: string,
    flag: string
}

export type CreateeAnnounSheet = {
    id?: number,
    title: string,
    content: string
    tags: number[],
    expired_at: string,
    postedDate?: string,
    postedBy?: string,
    updatedBy?: string,
    typeData: string
}


export type TemplateData = {
    id: number;
    name: string;
    viewColumns: string[];
};

export type ErrorState = {
    status?: number | string,
    data?: any | undefined,
    error?: string
}
export type TagInput = {
    name: string;
    flag: string;
}
export type PaginationData = {
    page: number;
    limit: number | string | undefined,
    search: string | number,
    tag: string | number | undefined,
    type: string | number | undefined,
    startDate?: string;
    endDate?: string;
    sort?:string;
}
export const deleteNotiToken = () => {
    // const app = initializeApp(firebaseConfig);
    // const messaging = getMessaging(app);
    // deleteToken(messaging).then((res) => {
    // }).catch(function (error) {
    //     console.error('Error deleting FCM token:', error);
    //   });;
}
export const redirectToLogin = () => {
    localStorage.clear();
    window.location.href = '/';
    deleteNotiToken();
}
export const notice_board_api = api.injectEndpoints({
    endpoints: (build) => ({
        getNoticeBoardData: build.query<AnnounSheetDataResponse, void>({
            query: () => ({
                url: `${endpointUrl}noticeboards`,
                headers: authHeader()
            }),
            keepUnusedDataFor:0,
            transformErrorResponse: (err) => {
                if (err?.status === 401) {
                    redirectToLogin();
                }
            },
            providesTags: ['NoticeBoard'],
        }),
        getAcknowledgeList: build.query<IAcknowledge, number>({
            query: (id) => ({
                url: `${endpointUrl}getnoticeacknowleged/${id}`,
                headers: authHeader()
            }),
            keepUnusedDataFor:0,
            transformErrorResponse: (err) => {
                if (err?.status === 401) {
                    redirectToLogin();
                }
            },
            providesTags: ['NoticeBoard'],
        }),
        getAllNoticeBoardListByDepartmentID: build.mutation<IAcknowledge, number>({
            query: (id) => ({
                url: `${endpointUrl}getnoticeacknowlegedDepartmentList/${id}`,
                headers: authHeader()
            }),
        }),
        getNoticeBoardListByDepartmentID: build.mutation<IAcknowledge, any>({
            query: (data) => ({
                url: `${endpointUrl}getnoticeacknowlegedEmployeeListByDepartment/${data.id}/${data.department_id}`,
                headers: authHeader()
            }),
        }),
        fetchNoticeBoardListByDepartmentID: build.query<any, any>({
            query: ({data}) => {
                return ({
                    url: `${endpointUrl}getnoticeacknowlegedEmployeeListByDepartment/${data.id}/${data.department_id}`,
                    headers: authHeader(),
                    keepUnusedDataFor:0,
                    keepalive:false
                })
            },
        }),
        getNoticeBoardDataWithPagination: build.query<NoticeBoardDataResponseCus, PaginationData>({
            query: ({ limit, page, search, tag, startDate, endDate, type,sort }) => ({
                url: `${endpointUrl}noticeboards?limit=${limit}&page=${page}&search=${search}&tag=${tag}&startDate=${startDate}&endDate=${endDate}&type=${type}&sort=${sort}`,
                headers: authHeader()
            }),
            keepUnusedDataFor:0,
            transformErrorResponse: (err) => {
                if (err?.status === 401) {
                    redirectToLogin();
                }
            },
            providesTags: ['NoticeBoard'],
        }),
        getNoticeBoardDataWithPaginationInfo: build.mutation<NoticeBoardDataResponseCus, PaginationData>({
            query: ({ limit, page, search, tag, startDate, endDate, type,sort }) => ({
                url: `${endpointUrl}noticeboards?limit=${limit}&page=${page}&search=${search}&tag=${tag}&startDate=${startDate}&endDate=${endDate}&type=${type}&sort=${sort}`,
                headers: authHeader()
            }),
        }),
        createNoticeBoard: build.mutation<CreateeAnnounSheet, Partial<CreateeAnnounSheet>>({
            query: (data) => ({
                url: `${endpointUrl}noticeboards`,
                method: "POST",
                headers: authHeader(),
                body: data,
            }),
            invalidatesTags: () => [{ type: 'NoticeBoard' }],
        }),
        updateNoticeBoard: build.mutation<CreateeAnnounSheet, Partial<CreateeAnnounSheet>>({
            query: ({ id, ...rest }) => {
                return {
                    url: `${endpointUrl}noticeboards/${id}`,
                    method: "PUT",
                    headers: authHeader(),
                    body: rest,
                }

            },
            invalidatesTags: () => [{ type: 'NoticeBoard' }],
        }),
        deleteNoticeBoard: build.mutation<{ id: number }, number>({
            query: (id) => ({
                url: `${endpointUrl}noticeboards/${id}`,
                method: 'DELETE',
                headers: authHeader(),
            }),
            invalidatesTags: ['NoticeBoard'],
        }),
        multiDeleteNoticeBoard: build.mutation<CreateeAnnounSheet, Partial<CreateeAnnounSheet>>({
            query: ({ id, ...rest }) => ({
                url: `${endpointUrl}noticeboards`,
                headers: authHeader(),
                method: 'DELETE',
                body: rest
            }),
            invalidatesTags: ['NoticeBoard'],
        }),
    })
});


export const {
    useGetNoticeBoardDataQuery,
    useGetNoticeBoardDataWithPaginationQuery,
    useCreateNoticeBoardMutation,
    useUpdateNoticeBoardMutation,
    useDeleteNoticeBoardMutation,
    useMultiDeleteNoticeBoardMutation,
    useGetAcknowledgeListQuery,
    useGetNoticeBoardDataWithPaginationInfoMutation,
    useGetNoticeBoardListByDepartmentIDMutation,
    useFetchNoticeBoardListByDepartmentIDQuery,
    useGetAllNoticeBoardListByDepartmentIDMutation
} = notice_board_api;

export const {
    endpoints: {
         getNoticeBoardData,
         getNoticeBoardDataWithPagination,
         createNoticeBoard,
         updateNoticeBoard,
         deleteNoticeBoard,
         multiDeleteNoticeBoard,
         getAcknowledgeList,
         getNoticeBoardDataWithPaginationInfo,
         getNoticeBoardListByDepartmentID,
         fetchNoticeBoardListByDepartmentID,
         getAllNoticeBoardListByDepartmentID
    },
} = notice_board_api;